module.exports = __webpack_public_path__ + "img/bingo_ball-84.0b1023ac.png";